<template>
  <div>
    <div class="monitor container is-fluid">
      <div class="columns">
        <page-header title="Terminales"></page-header>
      </div>
      <div class="columns">
        <div v-if="zona" class="column is-2">
          <dl>
            <dt>Zona</dt>
            <dd>
              <strong>{{ zona.nombre }}</strong>
            </dd>
          </dl>
        </div>
      </div>
      <div class="columns">
        <div class="column is-12">
          <b-table
            :narrowed="true"
            :bordered="true"
            :data="terminales"
            :paginated="true"
            :per-page="tamanoPagina"
            :current-page.sync="paginaActual"
            :pagination-simple="false"
            pagination-position="bottom"
            default-sort="user.id"
            aria-next-label="Siguiente página"
            aria-previous-label="Página anterior"
            aria-page-label="Página"
            aria-current-label="Página actual"
          >
            <b-table-column
              v-slot="props"
              field="id"
              label="Código"
              width="30"
              :centered="true"
            >
              <span> {{ props.row.id }} </span>
            </b-table-column>
            <b-table-column
              v-slot="props"
              field="nombre"
              label="Nombre Terminal"
            >
              <span> {{ props.row.nombre }} </span>
            </b-table-column>
            <b-table-column
              v-slot="props"
              field="tipoTerminal"
              label="Tipo Terminal"
              width="140"
            >
              <span> {{ props.row.tipoTerminal }} </span>
            </b-table-column>
            <b-table-column
              v-slot="props"
              field="direccion"
              label="Dirección"
              width="140"
            >
              <span> {{ props.row.direccion }} </span>
            </b-table-column>
            <b-table-column
              v-slot="props"
              field="puerto"
              label="Puerto"
              width="140"
            >
              <span> {{ props.row.puerto }} </span>
            </b-table-column>
            <b-table-column v-slot="props" label="Acciones" width="100">
              <b-button
                type="is-info"
                size="is-small"
                @click="modificarRegistro(props.row.id)"
              >
                <b-icon icon="pencil-alt" />
              </b-button>
              &nbsp;
              <b-button
                type="is-danger"
                size="is-small"
                @click="confirmarEliminarRegistro(props.row.id)"
              >
                <b-icon icon="trash-alt" />
              </b-button>
            </b-table-column>
            <template slot="empty">
              <div class="content has-text-grey has-text-centered">
                <p>No hay registros.</p>
              </div>
            </template>
          </b-table>
        </div>
      </div>
      <div class="columns">
        <div class="column is-12">
          <b-button
            type="is-info"
            icon-left="plus"
            :disabled="!puedeAgregar"
            @click="agregarRegistro"
          >
            Agregar
          </b-button>
          &nbsp;
          <button v-if="returnUrlExists" class="button" @click="goBackHandle">
            Volver
          </button>
        </div>
      </div>
    </div>
    <b-modal
      :active.sync="estaModalAbierto"
      has-modal-card
      trap-focus
      aria-role="dialog"
      aria-modal
      @close="cerrarModalHandle"
    >
      <terminal-form
        :modificacion="modificacion"
        :zona="zona"
        :objeto="objeto"
        :titulo="tituloForm"
        @close="cerrarModalHandle"
      />
    </b-modal>
  </div>
</template>

<script>
import qs from 'qs'

import PageHeader from '@/components/shared/PageHeader.vue'
import TerminalForm from '@/components/mantenedor/terminales/TerminalForm.vue'
import { zonaService } from '@/services'

export default {
  name: 'Terminales',
  components: {
    PageHeader,
    TerminalForm
  },
  data() {
    return {
      zona: null,
      terminales: [],
      estaModalAbierto: false,
      paginaActual: 1,
      tamanoPagina: 10,
      tituloForm: null,
      objeto: null,
      modificacion: false
    }
  },
  computed: {
    puedeAgregar: () => true,
    returnUrlExists() {
      return localStorage.getItem('returnUrl') != null
    }
  },
  created() {
    if (this.$route.params.id) {
      const zona = this.$route.params.id.toLowerCase()
      this.zona = { id: zona }
    }

    if (this.$route.query) {
      localStorage.setItem('returnUrl', qs.stringify(this.$route.query))
      this.$router.replace({ query: null }).catch((_) => {})
    }
  },
  mounted() {
    zonaService
      .getZona(this.zona.id)
      .then((response) => (this.zona = response.data))
      .catch((error) => this.procesarError(error))
    this.getTerminales()
  },
  methods: {
    agregarRegistro() {
      this.tituloForm = 'Agregar Terminal'
      this.estaModalAbierto = true
    },
    modificarRegistro(id) {
      this.tituloForm = 'Modificar Terminal'
      this.objeto = this.terminales.filter((item) => item.id === id)[0]
      this.modificacion = true
      this.estaModalAbierto = true
    },
    confirmarEliminarRegistro(id) {
      const objeto = this.terminales.filter((item) => item.id === id)[0]
      this.$buefy.dialog.confirm({
        title: 'Quitar terminal',
        message: `¿Est&aacute; seguro de <b>quitar</b> el terminal <b>${objeto.nombre}</b>?`,
        confirmText: 'Eliminar',
        cancelText: 'Cancelar',
        type: 'is-danger',
        hasIcon: true,
        onConfirm: () => this.eliminarRegistro(id)
      })
    },
    eliminarRegistro(id) {
      zonaService
        .deleteTerminal(this.zona.id, id)
        .then(() => {
          this.notificarAccionCompletada('Se eliminó el terminal correctamente')
          this.getTerminales()
        })
        .catch((error) => this.procesarError(error))
    },
    cerrarModalHandle(payload = false) {
      this.estaModalAbierto = false
      this.tituloForm = ''
      this.objeto = null
      this.modificacion = false
      if (payload) {
        this.getTerminales()
      }
    },
    getTerminales() {
      zonaService
        .getTerminales(this.zona.id)
        .then((response) => (this.terminales = response.data))
        .catch((error) => this.procesarError(error))
    },
    goBackHandle() {
      if (this.returnUrlExists) {
        const returnUrl = localStorage.getItem('returnUrl')
        localStorage.removeItem('returnUrl')
        this.$router.push(`/mantenedor/zonas?${returnUrl}`)
      }
    }
  }
}
</script>
